module.exports = __webpack_public_path__ + "img/TechInfCloseCombatExpertise_ua.312e9080.webp";